module.exports = __webpack_public_path__ + "img/logo.7c0614a6.png";